import React, { useState, Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { LoginLayout } from 'src/components/layouts/LoginLayout';
import StyleConfig from 'src/constants/StyleConfig';
import InputForm from 'src/components/atoms/form/InputForm';
import Button from 'src/components/atoms/button/Button';
import HomeButton from 'src/components/atoms/button/HomeButton';
import InputLabelHolder from 'src/components/molecules/form/InputLabelHolder';
import AnnotaionText from 'src/components/atoms/form/AnnotationText';
import { sendForgetPassWordEmail } from 'src/state/ducks/admin/actions';
import { APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import ErrorMessage from 'src/components/atoms/form/ErrorMessage';

interface Props {
  passwordForget: {
    isFetching: boolean;
    isSuccess: boolean;
    apiError: APIFailedResponse['error'] | undefined;
  };
  sendPasswordForgetMail: Function;
}

class PasswordForgetPage extends Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onSendPasswordForgetEmail = this.onSendPasswordForgetEmail.bind(this);
  }

  onSendPasswordForgetEmail = (email: string) => {
    const { sendPasswordForgetMail } = this.props;
    sendPasswordForgetMail(email);
  };
  render() {
    const { passwordForget } = this.props;
    return (
      <LoginLayout>
        <Block>
          <h1 className="logo">
            <img src="/images/pages/login/logo.png" alt={'sacri'} />
          </h1>
          <PasswordResetForm
            onSubmit={this.onSendPasswordForgetEmail}
            error={passwordForget.apiError}
            isSend={passwordForget.isSuccess}
          />
        </Block>
      </LoginLayout>
    );
  }
}

const PasswordResetForm = ({
  ...props
}: {
  onSubmit: (email: string) => void;
  isSend: boolean;
  error: Props['passwordForget']['apiError'];
}) => {
  const { error, isSend, onSubmit } = props;
  const [email, setEmail] = useState('');
  return (
    <StyledForm>
      <div className="item">
        <InputLabelHolder labelName="メールアドレス" isRequired />
        <InputForm
          inputType={'text'}
          inputValue={email}
          onChange={setEmail}
          placeholder={'forget@sacri.jp'}
          isError={false}
        />
        <AnnotaionText text={'入力されたメールにパスワードを再設定するリンクが送られます'} />
        {error ? <ErrorMessage marginVertical={8}>{error.message}</ErrorMessage> : null}
      </div>
      <div className="submit">
        <div className="submit-item">
          <Button
            type="button"
            isDisabled={isSend ? true : false}
            clickEvent={() => {
              onSubmit(email);
            }}
            text={`${isSend ? '送信しました' : '送信する'}`}
          />
        </div>
        <div className="submit-item">
          <HomeButton />
        </div>
      </div>
    </StyledForm>
  );
};

const Block = styled.div`
  .logo {
    width: 147px;
    margin: 0 auto ${StyleConfig.HELPER.M32};
    text-align: center;
  }
`;

const StyledForm = styled.form`
  display: block;
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
  > .submit {
    padding: ${StyleConfig.HELPER.M24} 0;
    .submit-item {
      margin-top: ${StyleConfig.HELPER.M20};
    }
  }
`;

const mapStateToProps = (state: any) => {
  return {
    passwordForget: state.admin.passwordForget,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    sendPasswordForgetMail: (email: string) => dispatch(sendForgetPassWordEmail(email)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordForgetPage);
